// @flow
import React, {PureComponent} from 'react';
import {dynamicClassName} from 'utils/dynamicClassName';
import { MOBILE_SIZE } from 'constants/app';

type Props = {
  hiddenMenuElements: any,
  activeTeam: any,
  switchTeam: any,
  level?: string,
  classLevel?: string,
  withoutCategories?: boolean,
};

type ComponentState = {
  isOpen: boolean
};

class TeamMenuDropdownMenu extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    isOpen: false
  };

  onClick = (e : MouseEvent) => {
    e.preventDefault();
    var element = document.getElementsByClassName('overlay');
    if (!this.state.isOpen) {
      for (var i = 0; i < element.length; i++) {
        element[i].classList.add('is-visible');
      }
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  };

  renderHiddenMenuElements(hiddenMenuElements : any, type : any) {
    const returnValue = [];
    var bAll = this;

    hiddenMenuElements.forEach(function(team, i) {
      if (!type || type === team.type_rugby) {
        returnValue.push(<li key={i}>
          <a 
            title={`Se rendre à la page ${team.title}`} 
            onClick={() => bAll._breakAll(team)}
            role="button"
            tabIndex={0}>
            {team.title}
          </a>
        </li>);
      }
    });
    return returnValue;
  }

  renderListMenuElements(hiddenMenuElements : any) {
    const returnList = [];
    const types_rugby = [];
    const me = this;
    for (let i = 0, len = hiddenMenuElements.length; i < len; i++) {
      if (types_rugby.indexOf(hiddenMenuElements[i].type_rugby) === -1) {
        types_rugby.push(hiddenMenuElements[i].type_rugby);
      }
    }
    types_rugby.forEach(function(type, index){
      const ulClassName = (window.innerWidth < MOBILE_SIZE) ? 'is-collapsed' : '';
      returnList.push(<li key={index}>
        <span className="menu-team__category">{type}</span>
        <ul className={ulClassName}>
          {me.renderHiddenMenuElements(hiddenMenuElements, type)}
        </ul>
      </li>); 
    });
    return returnList;
  }

  _breakAll = (team: Object) => {
    const element = document.querySelectorAll('.overlay');
    const firstLink = document.getElementsByClassName('accordion-trigger');
    const box = document.getElementById('boxTeam');

    for (let i = 0; i < element.length; i++) {
      element[i].classList.remove('is-visible');
    }
    if (box) {
      box.classList.add('is-hidden');
    }
    for (let j = 0; j < firstLink.length; j++) {
      firstLink[j].classList.remove('is-selected');
    }
    this.setState({
      isOpen: !this.state.isOpen
    });
    this.props.switchTeam(team);
  }

  _isOpenOverlay() {
    if (this.state.isOpen === true) {
      const element = document.querySelectorAll('.overlay');
      const firstLink = document.getElementsByClassName('accordion-trigger');
      const box = document.getElementById('boxTeam');

      for (let i = 0; i < element.length; i++) {
        element[i].onclick = () => {
          for (let i = 0; i < element.length; i++) {
            element[i].classList.remove('is-visible');
          }
          if (box) {
            box.classList.add('is-hidden');
          }

          for (let j = 0; j < firstLink.length; j++) {
            firstLink[j].classList.remove('is-selected');
          }
          this.setState({
            isOpen: !this.state.isOpen
          });
        };
      }
    }
  }

  render() {
    const {hiddenMenuElements, level, withoutCategories, classLevel} = this.props;
    const classNamesLink = dynamicClassName('accordion-trigger');
    this.state.isOpen && classNamesLink.add('is-selected');

    const classNamesDropdownMenu = dynamicClassName('accordion-panel has-overlay');
    !this.state.isOpen && classNamesDropdownMenu.add('is-hidden');
    const levelClass = classLevel ? classLevel : 'mb-3';
    if (hiddenMenuElements.length > 0) {
      return (
        <div className="menu-team">
          { level && level === 'h1' && 
          <h1 className={levelClass}>
            {
              hiddenMenuElements.length === 1
                ? (this.props.activeTeam.title)
                : (<a title="Voir les équipes de France"
                  role="button"
                  tabIndex="0"
                  onClick={this.onClick} 
                  className={classNamesLink.build()}>
                  {this.props.activeTeam.title}
                </a>)
            }
          </h1>}
          { (!level || level !== 'h1') && 
          <h2 className={levelClass}>
            {
              hiddenMenuElements.length === 1
                ? (this.props.activeTeam.title)
                : (<a title="Voir les équipes de France"
                  role="button"
                  tabIndex="0"
                  onClick={this.onClick} 
                  className={classNamesLink.build()}>
                  {this.props.activeTeam.title}
                </a>)
            }
          </h2>}

          <ul id="boxTeam" className={classNamesDropdownMenu.build()}>
            {this._isOpenOverlay()}
            { !withoutCategories &&
            this.renderListMenuElements(hiddenMenuElements) }
            { withoutCategories && 
            this.renderHiddenMenuElements(hiddenMenuElements) }
          </ul>
        </div>
      );
    }
    return null;
  }
}

export default TeamMenuDropdownMenu;
